import { useAuthStore } from '../store/authStore';

/**
 * Custom hook to access authentication state and actions.
 * This is a simple wrapper around the Zustand auth store.
 *
 * @returns Authentication state and methods
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const { user, isAuthenticated, login, logout } = useAuth();
 *
 *   if (!isAuthenticated) {
 *     return <button onClick={login}>Sign in</button>;
 *   }
 *
 *   return (
 *     <div>
 *       <p>Welcome, {user?.name}</p>
 *       <button onClick={logout}>Sign out</button>
 *     </div>
 *   );
 * }
 * ```
 */
export const useAuth = () => {
  const user = useAuthStore((state) => state.user);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isLoading = useAuthStore((state) => state.isLoading);
  const error = useAuthStore((state) => state.error);
  const login = useAuthStore((state) => state.login);
  const logout = useAuthStore((state) => state.logout);
  const setError = useAuthStore((state) => state.setError);

  return {
    user,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout,
    clearError: () => setError(null),
  };
};
